import React from "react";

class ChunkErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error) {
    if (
      error.name === "ChunkLoadError" ||
      error.message?.includes("Failed to fetch dynamically imported module")
    ) {
      return { hasError: true };
    }
    return { hasError: false };
  }

  componentDidCatch(error: Error) {
    if (
      error.name === "ChunkLoadError" ||
      error.message?.includes("Failed to fetch dynamically imported module")
    ) {
      const retried = sessionStorage.getItem("chunkReload");
      if (!retried) {
        sessionStorage.setItem("chunkReload", "1");
        window.location.reload();
      } else {
        console.error("Chunk reload already attempted. Not reloading again.");
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
